import type {PayloadAction} from '@reduxjs/toolkit'
import {createSlice} from '@reduxjs/toolkit'
import type {TGameSpectatorData, TPlayerId} from '@kapitalist/contract/types'

export type SpectatorState = {
  spectatorData: TGameSpectatorData[]
}

const initialState: SpectatorState = {
  spectatorData: [],
}

const spectatorSlice = createSlice({
  name: 'spectator',
  initialState,
  reducers: {
    setSpectatorData(
      state: SpectatorState,
      action: PayloadAction<TGameSpectatorData[]>
    ) {
      return {spectatorData: action.payload}
    },
  },
})

const {setSpectatorData} = spectatorSlice.actions
export {setSpectatorData}
export default spectatorSlice.reducer

export const spectatorsDataForPlayer = (
  playerId: TPlayerId,
  spectatorData: TGameSpectatorData[]
): TGameSpectatorData[] =>
  spectatorData.filter(sd => sd.spectatedPlayer.playerId === playerId)
